// extracted by mini-css-extract-plugin
module.exports = {"appBar":"_3IHC7jmcsIyulHImxLpblw"};